// src/components/DelegationFields.jsx
import { FormField } from "./FormField";

/**
 * Мультивыбор статусов задач для делегирования.
 *
 * Один компонент - одна разметка для двух модалок (передача полномочий
 * и отпуск). Если список статусов или порядок чекбоксов поменяются -
 * правка здесь применяется везде.
 *
 * Пустой набор означает «задачи не передавать»: никакого скрытого
 * «умолчания на все активные» нет ни здесь, ни в сервисах.
 */

export function RecipientSelect({
  label = "Получатель",
  value,
  onChange,
  options,
  error,
  disabled,
}) {
  return (
    <FormField
      label={label}
      required
      type="select"
      options={options}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
    />
  );
}
